import React, { useState, useEffect } from 'react';
import './App.css';
import Navbar from './Components/Navbar/Navbar';
import FloatingButtons from './Components/FloatingButtons/FloatingButtons';
import MainRoutes from './Routes/MainRoutes';
import Footer from './Components/Footer/Footer';
function App() {
  const [isScrolling, setIsScrolling] = useState(false);

  return (
    <div style={{ overflow: 'hidden' }}>
      <FloatingButtons />
      <Navbar />
      <MainRoutes />
      <Footer />
      {/* <img src={Logo} /> */}
    </div>
  );
}

export default App;
